var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState, useRef, createRef } from 'react';
import { createPortal } from 'react-dom';
import CustomiseModal from './CustomiseModal';
import { generateUID } from '../../helpers/urlHelpers';
import DynamicImage from './DynamicImage';
import AddToCartButton from '../atoms/AddToCartButton';
import ExportCanvas from './ExportProductCanvas';
import html2canvas from 'html2canvas';
import { extractImages, mapComponentVariants, getPossibleParams, findFirstAvailableVariants, findSelectedVariants, getVariantsFromURL, findRandomVariants, generateDynamicDataForImages } from '../baseHelpers';
import s3 from '../../helpers/awsConfig';
import ExportAddOnsCanvas from './ExportAddOnsCanvas';
import SwatchGrid from '../atoms/SwatchGrid';
import VariantImageCarousel from '../atoms/VariantImageCarousel';
import SummaryProducts from '../atoms/SummaryProducts';
import EditButtons from '../atoms/EditButtons';
import GiftSetButtons from '../atoms/GiftSetButtons';
const CustomiserBase = ({ 
// Main Product Container
mainProductContainer, 
// Portals
staticProductImage, customiserProductImage, addToCartButtonContainer, 
// Misc.
strings, baseProduct, bundleComponents, addOns, summaryBar, variantsWrapper, thumbnailContainer, colourSwatchOrder, settings, customiserTools, mediaWrapper, }) => {
    // Current product state
    const [isCustomisable, setIsCustomisable] = useState(baseProduct.has_components);
    const [isGiftSet] = useState(bundleComponents.length > 1);
    const [showRandomiseBtn, setShowRandomiseBtn] = useState(false);
    const [currentSelectedBundle, setCurrentSelectedBundle] = useState(null);
    const [allImages, setAllImages] = useState([]);
    const [allImagesDynamicData, setAllImagesDynamicData] = useState([]);
    const [loadingNewPart, setLoadingNewPart] = useState(false);
    // Extras
    const [currentAddOns, setCurrentAddOns] = useState([]);
    const [monogrammingBasePrice, setMonogrammingBasePrice] = useState(null);
    const [monogrammingActive, setMonogrammingActive] = useState([]);
    const [monogrammingBackActive, setMonogrammingBackActive] = useState([]);
    const [disableBannedWord, setDisableBadWord] = useState(false);
    // Modal state
    const [modalOpen, setModalOpen] = useState(false);
    const [steps, setSteps] = useState([]);
    const [currentStep, setCurrentStep] = useState({ index: 0, type: 'product-select' });
    const [openStepAccordion, setOpenStepAccordion] = useState(0);
    const [currentFocusedBaseProduct, setCurrentFocusedBaseProduct] = useState(0);
    const [currentFocusedComponent, setCurrentFocusedComponent] = useState(0);
    const [currentFocusedProduct, setCurrentFocusedProduct] = useState(0);
    const [showSummaryBar, setShowSummaryBar] = useState(false);
    const [activeEmblaApi, setActiveEmblaApi] = useState(null);
    // Export
    const exportCanvasRef = useRef(null);
    const exportAddOnsCanvasRef = useRef(addOns.map(() => createRef()));
    const [thumbnailArtwork, setThumbnailArtwork] = useState('');
    const [addOnArtwork, setAddOnArtwork] = useState([]);
    const [uniqueID, setUniqueID] = useState(null);
    const [customCheckoutImage, setCustomCheckoutImage] = useState(settings.checkout_bundle_image);
    const [replaceCheckoutImage, setReplaceCheckoutImage] = useState(true);
    // Generating Thumbnmails
    const [bundleEdited, setBundleEdited] = useState({ count: 0, context: 'main', element: '' });
    const debounceTimeoutRef = useRef(null);
    const debounce = (func, delay) => {
        clearTimeout(debounceTimeoutRef.current);
        debounceTimeoutRef.current = setTimeout(func, delay);
    };
    const selectPartColor = (baseProdIndex, compIndex, prodIndex, variantName) => {
        var _a;
        const componentKeys = Object.keys(currentSelectedBundle[baseProdIndex]);
        const componentKey = componentKeys[compIndex];
        const currentItem = currentSelectedBundle[baseProdIndex][componentKey][prodIndex];
        if (((_a = currentItem.selectedVariant) === null || _a === void 0 ? void 0 : _a.title) === variantName)
            return;
        const partArray = currentSelectedBundle[baseProdIndex][componentKey].map((item, idx) => {
            if (idx === prodIndex) {
                const newVariant = item.otherVariants.find((variant) => variant.title === variantName);
                return Object.assign(Object.assign({}, item), { selectedVariant: newVariant });
            }
            return item;
        });
        // Update state
        const updatedBaseProduct = Object.assign(Object.assign({}, currentSelectedBundle[baseProdIndex]), { [componentKey]: partArray });
        const updatedBundle = currentSelectedBundle.map((item, idx) => (idx === baseProdIndex ? updatedBaseProduct : item));
        setCurrentSelectedBundle(updatedBundle);
        setBundleEdited((prev) => ({ count: prev.count + 1, context: 'main', element: 'part' }));
        setCurrentFocusedBaseProduct(baseProdIndex);
        setCurrentFocusedComponent(compIndex);
        setCurrentFocusedProduct(prodIndex);
    };
    // Modal Functionality
    const openModal = () => {
        setModalOpen(true);
        mainProductContainer.classList.add('product__inner--customiser-open');
    };
    const closeModal = () => {
        setModalOpen(false);
        setCurrentStep({ index: 0, type: 'product-select' });
        mainProductContainer.classList.remove('product__inner--customiser-open');
        // Full Height view when existing the customiser
        const smallProductImage = document.querySelector('.product__image--small');
        if (smallProductImage) {
            smallProductImage.classList.remove('product__image--small');
        }
    };
    // Component Select
    const selectNewComponent = (componentName, newProductName, baseProdIndex) => {
        setLoadingNewPart(true);
        const selectedComponent = bundleComponents[baseProdIndex].components.find((component) => component.name == componentName);
        const selectedProduct = selectedComponent.products.find((product) => product.part_type == newProductName);
        // Check if new part is available in the same colour
        const currentColour = currentSelectedBundle[baseProdIndex][componentName][0].selectedVariant.colour_swatch.name;
        const selectedVariants = [];
        if (selectedProduct.inner_parts) {
            selectedProduct.inner_parts.products.forEach((innerProduct) => {
                let found = false;
                innerProduct.variants.forEach((innerVariant) => {
                    if (!found && innerVariant.colour_swatch && innerVariant.colour_swatch.name == currentColour) {
                        selectedVariants.push({
                            selectedVariant: innerVariant,
                            product: selectedProduct.part_type,
                            component: componentName,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            monogramming: innerProduct.monogramming,
                            part_title: innerProduct.part_title,
                        });
                        found = true;
                    }
                });
                if (found == false) {
                    let findAvailable = false;
                    innerProduct.variants.forEach((innerVariant) => {
                        if (!findAvailable && innerVariant.available) {
                            selectedVariants.push({
                                selectedVariant: innerVariant,
                                product: selectedProduct.part_type,
                                component: componentName,
                                part: innerProduct.part_type,
                                otherVariants: innerProduct.variants,
                                title: innerProduct.title,
                                monogramming: innerProduct.monogramming,
                                part_title: innerProduct.part_title,
                            });
                            findAvailable = true;
                        }
                    });
                }
            });
        }
        else {
            let found = false;
            selectedProduct.variants.forEach((innerVariant) => {
                if (!found && innerVariant.colour_swatch && innerVariant.colour_swatch.name == currentColour) {
                    selectedVariants.push(Object.assign(Object.assign({ selectedVariant: innerVariant, component: componentName, otherVariants: selectedProduct.variants }, selectedProduct), { product: selectedProduct.part_type, part: selectedProduct.part_type, title: selectedProduct.title, monogramming: selectedProduct.monogramming, part_title: selectedProduct.part_title }));
                    found = true;
                }
            });
            if (!found) {
                let findAvailable = false;
                selectedProduct.variants.forEach((innerVariant) => {
                    if (!findAvailable && innerVariant.available) {
                        selectedVariants.push({
                            selectedVariant: innerVariant,
                            component: componentName,
                            product: selectedProduct.part_type,
                            part: selectedProduct.part_type,
                            otherVariants: selectedProduct.variants,
                            title: selectedProduct.title,
                            monogramming: selectedProduct.monogramming,
                            part_title: selectedProduct.part_title,
                        });
                        findAvailable = true;
                    }
                });
            }
        }
        // Find old componnent in URL and remove
        removeOldParamsForComponent(componentName, baseProdIndex);
        const newBundle = [...currentSelectedBundle];
        newBundle[baseProdIndex] = Object.assign(Object.assign({}, newBundle[baseProdIndex]), { [componentName]: selectedVariants });
        const componentKeys = Object.keys(currentSelectedBundle[baseProdIndex]);
        const componentIndex = componentKeys.indexOf(componentName);
        // set new bundle
        setCurrentSelectedBundle(newBundle);
        setBundleEdited({ count: bundleEdited.count + 1, context: 'main', element: 'part' });
        setCurrentFocusedBaseProduct(baseProdIndex);
        setCurrentFocusedComponent(componentIndex);
        setCurrentFocusedProduct(0);
    };
    const removeOldParamsForComponent = (componentName, prodIndex) => {
        const url = new URL(window.location.href);
        const items = currentSelectedBundle[prodIndex][componentName];
        const isMultiple = items.length > 1;
        items.forEach((item) => {
            const key = isMultiple ? `${prodIndex + 1}--${componentName}--${item.product}--${item.part}` : `${prodIndex + 1}--${componentName}--${item.part}`;
            url.searchParams.delete(key);
        });
        // Single replaceState call
        history.replaceState({}, '', url.toString());
    };
    // ADD ONS
    const toggleAddOnProduct = (addOn) => {
        const current = currentAddOns.find((add) => add.part_type == addOn.part_type);
        const index = addOns.indexOf(addOn);
        if (current) {
            // Remove from the state
            setCurrentAddOns((prevItems) => prevItems.filter((item) => item.part_type != addOn.part_type));
        }
        else {
            // Add the addOn
            const newAddOn = {};
            newAddOn.isSelected = true;
            newAddOn.price = addOn.price;
            newAddOn.part_type = addOn.part_type;
            newAddOn.handle = addOn.handle;
            newAddOn.compare_at_price = addOn.compare_at_price;
            newAddOn.index = index;
            newAddOn.checkoutImage = addOn.checkout_custom_image;
            if (addOn.inner_parts) {
                newAddOn.products = addOn.inner_parts.products.map((innerProduct) => {
                    return {
                        selectedVariant: innerProduct.variants[0],
                        product: addOn.part_type,
                        part: innerProduct.part_type,
                        otherVariants: innerProduct.variants,
                        title: innerProduct.title,
                    };
                });
                newAddOn.products = [
                    ...newAddOn.products,
                    {
                        selectedVariant: addOn.variants[0],
                        product: addOn.part_type,
                        part: 'parent-product',
                        otherVariants: addOn.variants,
                        title: addOn.title,
                    },
                ];
            }
            else {
                newAddOn.products = [
                    {
                        selectedVariant: addOn.variants[0],
                        product: addOn.part_type,
                        part: 'parent-product',
                        otherVariants: addOn.variants,
                        title: addOn.title,
                    },
                ];
            }
            newAddOn.selectedPart = newAddOn.products[0];
            setCurrentAddOns((prevItems) => [...prevItems, newAddOn]);
        }
        setBundleEdited({ count: bundleEdited.count + 1, context: '-add-on', element: '' });
    };
    const selectAddOnPartColor = (addOn, product, variant) => {
        setCurrentAddOns((prevItems) => prevItems.map((item) => item.part_type === addOn
            ? Object.assign(Object.assign({}, item), { products: item.products.map((innerProduct) => {
                    const isCurrentProduct = innerProduct.part == product;
                    return Object.assign(Object.assign({}, innerProduct), { selectedVariant: isCurrentProduct ? variant : innerProduct.selectedVariant });
                }) }) : item));
        setBundleEdited({ count: bundleEdited.count + 1, context: '-add-on', element: '' });
    };
    // MONOGRAMMING
    const editMonogramming = (baseProd, comp, prod, newValue, maxLength, side) => {
        // Crop to max length
        if (newValue.length > maxLength) {
            newValue = newValue.slice(0, maxLength);
        }
        // Remove invalid characters
        const validCharacters = /^[A-Za-z0-9 `~!@#$%^&*()\-_=+\[\]{}\\|;:'",<.>\/?]*$/;
        if (!validCharacters.test(newValue)) {
            newValue = newValue.replace(/[^A-Za-z0-9 `~!@#$%^&*()\-_=+\[\]{}\\|;:'",<.>\/?]/g, '');
        }
        // Check for bad words
        const enteredPhrase = newValue.toLowerCase().split(' ');
        let foundBad = false;
        enteredPhrase.forEach((word) => {
            if (!foundBad) {
                if (settings.banned_words.includes(word.replace(/\s+/g, '')) || settings.banned_words.includes(word) || settings.banned_words.includes(newValue)) {
                    setDisableBadWord(true);
                    foundBad = true;
                }
                else {
                    setDisableBadWord(false);
                }
            }
        });
        const updatedBundle = currentSelectedBundle;
        Object.values(updatedBundle[baseProd])[comp][prod][side].value = newValue;
        Object.values(updatedBundle[baseProd])[comp][prod][side].included = newValue != '';
        setCurrentSelectedBundle([...updatedBundle]);
        setBundleEdited({ count: bundleEdited.count + 1, context: 'main', element: 'monogram' });
    };
    const selectEmoji = (baseProd, comp, prod, emojiIndex, side) => {
        const emojiCount = Object.values(currentSelectedBundle[baseProd])[comp][prod][side].emojis.filter((emo) => emo.selected);
        const maxCount = Object.values(currentSelectedBundle[baseProd])[comp][prod][side].emoji_limit;
        const currentState = Object.values(currentSelectedBundle[baseProd])[comp][prod][side].emojis[emojiIndex].selected;
        if (emojiCount.length >= maxCount && currentState == false)
            return;
        const updatedBundle = currentSelectedBundle;
        Object.values(updatedBundle[baseProd])[comp][prod][side].emojis[emojiIndex].selected = !currentState;
        Object.values(updatedBundle[baseProd])[comp][prod][side].emojis[emojiIndex].timestamp = currentState == true ? '' : Date.now();
        setCurrentSelectedBundle([...updatedBundle]);
        setBundleEdited({ count: bundleEdited.count + 1, context: 'main', element: 'monogram' });
    };
    const checkIfHasMonogramming = (allProducts, alreadySet) => {
        if (alreadySet)
            return alreadySet;
        let monogrammingPrice = null;
        allProducts.forEach((product) => {
            product.products.forEach((element) => {
                if (element.inner_parts) {
                    return checkIfHasMonogramming([element.inner_parts], alreadySet);
                }
                else {
                    if (element.monogramming && typeof element.monogramming.price === 'number' && !isNaN(element.monogramming.price)) {
                        monogrammingPrice = element.monogramming.price;
                    }
                }
            });
        });
        setMonogrammingBasePrice(monogrammingPrice);
        return monogrammingPrice != null;
    };
    const updateMonogrammingPlacement = (baseProd, comp, prod, side, position) => {
        const updatedBundle = currentSelectedBundle;
        Object.values(updatedBundle[baseProd])[comp][prod][side].placement = position;
        setCurrentSelectedBundle([...updatedBundle]);
        setBundleEdited({ count: bundleEdited.count + 1, context: 'main', element: 'monogram' });
    };
    // SWATCHES
    const sortSwatches = (swatches) => {
        const orderMap = new Map(colourSwatchOrder.map((name, index) => [name, index]));
        return swatches.slice().sort((a, b) => {
            var _a, _b;
            return ((_a = orderMap.get(a.name)) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER) - ((_b = orderMap.get(b.name)) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER);
        });
    };
    // MODAL STEPS
    const generateModalSteps = (bundleProd, bundle, prodIndex) => {
        let initSteps = [];
        // Add steps to choose part products
        function configureInnerPartStep(componentGroup, bundleGroup, prodIndex, compIndex) {
            const currentProduct = bundleGroup[componentGroup.name].length ? bundleGroup[componentGroup.name][0].product : null;
            const currentShortTitle = bundleGroup[componentGroup.name].length == 1 ? bundleGroup[componentGroup.name][0].part_title : componentGroup.display_title;
            const existingStep = initSteps.find((step) => step.title == `${strings.part_choose_prefix} ${currentShortTitle}`);
            const hasVariants = componentGroup.products.length > 1 || (componentGroup.products.length == 1 && componentGroup.products.some((prod) => prod.variants.length > 1)) || (componentGroup.products.length == 1 && componentGroup.products.some((prod) => prod.inner_parts != undefined));
            if (existingStep) {
                const existingIndex = initSteps.indexOf(existingStep);
                initSteps[existingIndex] = {
                    title: `${strings.part_choose_prefix} ${currentShortTitle}`,
                    mobileTitle: currentShortTitle,
                    stepInfo: {
                        type: 'product-select',
                        hasVariants: hasVariants,
                        selected: [...existingStep.stepInfo.selected, currentProduct],
                        componentIndex: compIndex,
                        partButtons: [
                            ...existingStep.stepInfo.partButtons,
                            componentGroup.products.map((product) => {
                                let surcharge = false;
                                let out_of_stock = false;
                                let surchargeAmount = 0;
                                if (product.inner_parts) {
                                    surcharge = product.inner_parts.products.some((innerPart) => innerPart.variants.every((variant) => variant.surcharge_price));
                                    out_of_stock = product.inner_parts.products.every((innerPart) => innerPart.variants.every((variant) => variant.available == false));
                                }
                                else {
                                    surcharge = product.variants.every((variant) => variant.surcharge_price);
                                    out_of_stock = product.variants.every((variant) => variant.available == false);
                                }
                                if (surcharge) {
                                    if (product.inner_parts) {
                                        surchargeAmount = product.inner_parts.products.find((innerPart) => innerPart.variants.every((variant) => variant.surcharge_price)).variants[0].surcharge_price;
                                    }
                                    else {
                                        surchargeAmount = product.variants[0].surcharge_price;
                                    }
                                }
                                return {
                                    title: product.title,
                                    part_type: product.part_type,
                                    component: componentGroup.name,
                                    prodIndex: prodIndex,
                                    tooltip: product.tooltip,
                                    svg_icon: product.svg_icon,
                                    surcharge: surchargeAmount,
                                    out_of_stock: out_of_stock,
                                };
                            }),
                        ],
                        component: componentGroup.name,
                        parentProducts: [...existingStep.stepInfo.parentProducts, isGiftSet ? componentGroup.products[0].giftset_part_title : componentGroup.products[0].parent_product],
                    },
                };
            }
            else {
                initSteps.push({
                    title: `${strings.part_choose_prefix} ${currentShortTitle}`,
                    mobileTitle: currentShortTitle,
                    stepInfo: {
                        type: 'product-select',
                        hasVariants: hasVariants,
                        selected: [currentProduct],
                        componentIndex: compIndex,
                        partButtons: [
                            componentGroup.products.map((product) => {
                                let surcharge = false;
                                let out_of_stock = false;
                                let surchargeAmount = 0;
                                if (product.inner_parts) {
                                    surcharge = product.inner_parts.products.some((innerPart) => innerPart.variants.every((variant) => variant.surcharge_price));
                                    out_of_stock = product.inner_parts.products.every((innerPart) => innerPart.variants.every((variant) => variant.available == false));
                                }
                                else {
                                    surcharge = product.variants.every((variant) => variant.surcharge_price);
                                    out_of_stock = product.variants.every((variant) => variant.available == false);
                                }
                                if (surcharge) {
                                    if (product.inner_parts) {
                                        surchargeAmount = product.inner_parts.products.find((innerPart) => innerPart.variants.every((variant) => variant.surcharge_price)).variants[0].surcharge_price;
                                    }
                                    else {
                                        surchargeAmount = product.variants[0].surcharge_price;
                                    }
                                }
                                return {
                                    title: product.title,
                                    part_type: product.part_type,
                                    component: componentGroup.name,
                                    prodIndex: prodIndex,
                                    tooltip: product.tooltip,
                                    svg_icon: product.svg_icon,
                                    surcharge: surchargeAmount,
                                    out_of_stock: out_of_stock,
                                };
                            }),
                        ],
                        component: componentGroup.name,
                        parentProducts: [isGiftSet ? componentGroup.products[0].giftset_part_title : componentGroup.products[0].parent_product],
                    },
                });
            }
        }
        bundleProd.components.forEach((innerComponent, compIndex) => {
            configureInnerPartStep(innerComponent, bundle, prodIndex, compIndex);
        });
        function configureMonogrammingStep(bundleGroup, index) {
            for (const component in bundleGroup) {
                const existingStep = initSteps.find((step) => step.title == strings.monogramming.title);
                bundleGroup[component].forEach((componentProd) => {
                    if (componentProd.monogramming && componentProd.monogramming.variant_id) {
                        const relatedComponent = bundleComponents[index].components.find((comp) => comp.name == component);
                        if (existingStep) {
                            const existingIndex = initSteps.indexOf(existingStep);
                            initSteps[existingIndex] = {
                                title: strings.monogramming.title,
                                mobileTitle: strings.monogramming.mobile_title,
                                stepInfo: {
                                    type: 'monogramming',
                                    price: componentProd.monogramming.price,
                                    parentProducts: [...existingStep.stepInfo.parentProducts, isGiftSet ? relatedComponent.products[0].giftset_part_title : relatedComponent.products[0].parent_product],
                                },
                            };
                        }
                        else {
                            initSteps.push({
                                title: strings.monogramming.title,
                                mobileTitle: strings.monogramming.mobile_title,
                                stepInfo: {
                                    type: 'monogramming',
                                    price: componentProd.monogramming.price,
                                    parentProducts: [isGiftSet ? relatedComponent.products[0].giftset_part_title : relatedComponent.products[0].parent_product],
                                },
                            });
                        }
                    }
                });
            }
        }
        function configureBackMonogrammingStep(bundleGroup, index) {
            for (const component in bundleGroup) {
                const existingStep = initSteps.find((step) => step.title == strings.monogramming.back_title);
                bundleGroup[component].forEach((componentProd) => {
                    if (componentProd.monogramming_back && componentProd.monogramming_back.variant_id) {
                        const relatedComponent = bundleComponents[index].components.find((comp) => comp.name == component);
                        if (existingStep) {
                            const existingIndex = initSteps.indexOf(existingStep);
                            initSteps[existingIndex] = {
                                title: strings.monogramming.back_title,
                                mobileTitle: strings.monogramming.mobile_back_title,
                                stepInfo: {
                                    type: 'monogramming-back',
                                    price: componentProd.monogramming_back.price,
                                    parentProducts: [...existingStep.stepInfo.parentProducts, isGiftSet ? relatedComponent.products[0].giftset_part_title : relatedComponent.products[0].parent_product],
                                },
                            };
                        }
                        else {
                            initSteps.push({
                                title: strings.monogramming.back_title,
                                mobileTitle: strings.monogramming.mobile_back_title,
                                stepInfo: {
                                    type: 'monogramming-back',
                                    price: componentProd.monogramming_back.price,
                                    parentProducts: [isGiftSet ? relatedComponent.products[0].giftset_part_title : relatedComponent.products[0].parent_product],
                                },
                            });
                        }
                    }
                });
            }
        }
        // Add monogramming
        if (monogrammingBasePrice != null) {
            configureMonogrammingStep(bundle, prodIndex);
            configureBackMonogrammingStep(bundle, prodIndex);
        }
        // Add add ons
        if (addOns.length) {
            initSteps.push({
                title: strings.add_ons_title,
                mobileTitle: strings.mobile_add_ons_title,
                stepInfo: {
                    type: 'add-ons',
                },
            });
        }
        let stepCount = 0;
        initSteps = initSteps.map((step) => {
            if (step.stepInfo.type == 'product-select' && step.stepInfo.hasVariants == false) {
                // skip
            }
            else {
                stepCount += 1;
            }
            return Object.assign(Object.assign({}, step), { stepNumber: stepCount, hideStep: step.stepInfo.type == 'product-select' && step.stepInfo.hasVariants == false });
        });
        let filteredSteps = initSteps;
        if (initSteps.length > 1) {
            filteredSteps = initSteps.filter((step) => step.hideStep == false);
        }
        return filteredSteps;
    };
    // USEEFFECT: First Load
    useEffect(() => {
        const parsedUrl = new URL(window.location.href);
        const queryParams = parsedUrl.searchParams;
        if (bundleComponents.length) {
            const selectedBundle = [];
            const url = new URL(window.location.href); // new instance we'll mutate
            if (queryParams.size > 0) {
                // Build list of all valid param keys
                let allParams = [];
                bundleComponents.forEach((bundleProd, index) => {
                    const possibleParams = getPossibleParams(bundleProd.components, `${index + 1}--`);
                    allParams = [...allParams, ...possibleParams];
                });
                // Clean out all params not in the valid list (except 'variant')
                const seenKeys = new Set();
                for (const [key] of url.searchParams.entries()) {
                    if (seenKeys.has(key)) {
                        url.searchParams.delete(key); // removes *all* duplicates
                    }
                    else {
                        seenKeys.add(key);
                    }
                    if (key !== 'variant' && !allParams.includes(key)) {
                        url.searchParams.delete(key);
                    }
                }
                // Replace URL once with cleaned params
                history.replaceState({}, '', url.toString());
                // Determine selected variants from URL
                let hasMonogramming = false;
                if (url.searchParams.size > 0) {
                    bundleComponents.forEach((bundleProd, prodIndex) => {
                        const selectedVariants = getVariantsFromURL(url.searchParams, bundleProd.components, prodIndex);
                        selectedBundle.push(selectedVariants);
                        hasMonogramming = checkIfHasMonogramming(bundleProd.components, hasMonogramming);
                    });
                }
                else {
                    bundleComponents.forEach((bundleProd) => {
                        const selectedVariants = bundleProd.default_parts.length ? findSelectedVariants(bundleProd.components, bundleProd.default_parts) : findFirstAvailableVariants(bundleProd.components);
                        selectedBundle.push(selectedVariants);
                        hasMonogramming = checkIfHasMonogramming(bundleProd.components, hasMonogramming);
                    });
                }
                setIsCustomisable(hasMonogramming || baseProduct.has_components);
            }
            else {
                let hasMonogramming = false;
                bundleComponents.forEach((bundleProd) => {
                    if (queryParams.size > 0)
                        return;
                    const selectedVariants = bundleProd.default_parts.length ? findSelectedVariants(bundleProd.components, bundleProd.default_parts) : findFirstAvailableVariants(bundleProd.components);
                    selectedBundle.push(selectedVariants);
                    hasMonogramming = checkIfHasMonogramming(bundleProd.components, hasMonogramming);
                });
                setIsCustomisable(hasMonogramming || baseProduct.has_components);
            }
            setCurrentSelectedBundle(selectedBundle);
            // Check for variant support to enable randomise button
            const variantsFound = bundleComponents.some((bundleProd) => { var _a; return bundleProd.product.variants.length > 1 || ((_a = bundleProd.components) === null || _a === void 0 ? void 0 : _a.some((comp) => comp.products.some((prod) => prod.variants.length > 1))); });
            setShowRandomiseBtn(variantsFound && isCustomisable);
            // Init thumbnail/artwork
            const uid = generateUID();
            setUniqueID(uid);
            const allVariantImages = bundleComponents.map((bundleProduct) => extractImages(bundleProduct.components, bundleProduct.product.handle));
            setAllImages(allVariantImages);
        }
        if (baseProduct.checkout_custom_image) {
            setReplaceCheckoutImage(false);
            setCustomCheckoutImage(baseProduct.checkout_custom_image);
        }
    }, []);
    useEffect(() => {
        setBundleEdited({ count: bundleEdited.count + 1, context: 'main', element: 'first-load' });
        setThumbnailArtwork(`https://s3.ap-southeast-2.amazonaws.com/bundle-images.frank-green/${baseProduct.handle}-${uniqueID}.png`);
        setAddOnArtwork(addOns.map((addOn, index) => `https://s3.ap-southeast-2.amazonaws.com/bundle-images.frank-green/${baseProduct.handle}-add-on${index}-${uniqueID}.png`));
    }, [uniqueID]);
    // USEEFFECT: Bundle Updated
    useEffect(() => {
        if (currentSelectedBundle && bundleEdited.context == 'main') {
            // if colours or parts have been updated, redefine the url and solid colour options
            if (bundleEdited.element == 'part' || bundleEdited.element == 'first-load') {
                const mappedVariants = mapComponentVariants(currentSelectedBundle);
                let allParams = [];
                bundleComponents.forEach((bundleProd, index) => {
                    const possibleParams = getPossibleParams(bundleProd.components, `${index + 1}--`);
                    allParams = [...allParams, ...possibleParams];
                });
                // @ts-ignore
                const url = new URL(window.location.href);
                for (const [key] of url.searchParams.entries()) {
                    if (key !== 'variant') {
                        url.searchParams.delete(key);
                    }
                }
                // Apply mappedVariants if available
                if (mappedVariants) {
                    for (const key in mappedVariants) {
                        const newValue = mappedVariants[key];
                        const currentValue = url.searchParams.get(key);
                        if (currentValue !== newValue && allParams.includes(key)) {
                            url.searchParams.set(key, newValue);
                        }
                    }
                }
                const seenKeys = new Set();
                for (const [key] of url.searchParams.entries()) {
                    if (seenKeys.has(key)) {
                        url.searchParams.delete(key); // removes *all* duplicates
                    }
                    else {
                        seenKeys.add(key);
                    }
                    if (key !== 'variant' && !allParams.includes(key)) {
                        url.searchParams.delete(key);
                    }
                }
                // Replace the URL just once
                history.replaceState({}, '', url.toString());
            }
            if (bundleEdited.element == 'monogram' || bundleEdited.element == 'first-load') {
                // Check if monogramming is active
                const monogrammingState = monogrammingActive;
                const monogrammingBackState = monogrammingBackActive;
                currentSelectedBundle.forEach((bundleProduct, index) => {
                    monogrammingState[index] = false;
                    monogrammingBackState[index] = false;
                    for (const component in bundleProduct) {
                        bundleProduct[component].forEach((componentProd) => {
                            var _a, _b, _c, _d;
                            const selectedEmoji = (_b = (_a = componentProd.monogramming) === null || _a === void 0 ? void 0 : _a.emojis) === null || _b === void 0 ? void 0 : _b.some((emoji) => emoji.selected);
                            if (componentProd.monogramming && (((_c = componentProd.monogramming.value) === null || _c === void 0 ? void 0 : _c.length) > 0 || selectedEmoji)) {
                                monogrammingState[index] = true;
                            }
                            if (componentProd.monogramming_back && ((_d = componentProd.monogramming_back.value) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                                monogrammingBackState[index] = true;
                            }
                        });
                    }
                });
                setMonogrammingActive(monogrammingState);
                setMonogrammingBackActive(monogrammingBackState);
            }
            const allSteps = [];
            bundleComponents.forEach((component, index) => {
                const initSteps = generateModalSteps(component, currentSelectedBundle[index], index);
                allSteps.push(initSteps);
            });
            // Generate modal steps
            setSteps(allSteps);
            // Generate dynamic state for images
            const dynamicState = [];
            bundleComponents.forEach((bundleProduct, index) => {
                const imageArray = generateDynamicDataForImages(currentSelectedBundle[index], bundleProduct.components, index);
                dynamicState.push(imageArray);
            });
            setAllImagesDynamicData(dynamicState);
        }
    }, [currentSelectedBundle]);
    // FINAL ARTWORK
    const generateThumbnail = (context, fileName, index) => __awaiter(void 0, void 0, void 0, function* () {
        const currentRef = context === 'main' ? exportCanvasRef.current : exportAddOnsCanvasRef.current[index].current;
        if (currentRef === null) {
            return false;
        }
        try {
            const canvas = yield html2canvas(currentRef, { allowTaint: true, backgroundColor: null });
            const imgData = canvas.toDataURL('image/png');
            const artwork = yield uploadToImageS3(imgData, `${baseProduct.handle}${fileName}-${uniqueID}.png`);
            return true;
        }
        catch (err) {
            console.log(err);
            return false;
        }
    });
    useEffect(() => {
        debounce(() => {
            if (bundleEdited.element == 'first-load') {
                generateThumbnail('main', '');
                currentAddOns.forEach((addOnItem) => generateThumbnail('addOn', `-add-on${addOnItem.index}`, addOnItem.index));
            }
            else if (bundleEdited.context == 'main') {
                generateThumbnail('main', '');
            }
            else {
                currentAddOns.forEach((addOnItem) => generateThumbnail('addOn', `-add-on${addOnItem.index}`, addOnItem.index));
            }
        }, 500); // 500ms debounce delay
    }, [bundleEdited]);
    const convertToBlob = (dataURI) => {
        const binary = atob(dataURI.split(',')[1]);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], { type: 'image/png' });
    };
    const uploadToImageS3 = (dataURI, fileName) => __awaiter(void 0, void 0, void 0, function* () {
        const blob = convertToBlob(dataURI);
        const params = {
            Bucket: 'bundle-images.frank-green',
            Key: fileName,
            Body: blob,
            ContentType: 'image/png',
            ACL: 'public-read',
        };
        try {
            const uploadResult = yield s3.upload(params).promise();
            return uploadResult.Location;
        }
        catch (error) {
            console.error('Error uploading to S3:', error);
            throw error;
        }
    });
    useEffect(() => {
        setOpenStepAccordion(currentStep.index);
    }, [currentStep]);
    const selectPartToEdit = (baseProdIndex, compIndex, productIndex) => {
        setCurrentFocusedBaseProduct(baseProdIndex);
        setCurrentFocusedComponent(compIndex);
        setCurrentFocusedProduct(productIndex);
        setCurrentStep({ index: compIndex, type: steps[baseProdIndex][compIndex].stepInfo.type });
        if (modalOpen == false) {
            openModal();
        }
    };
    const selectNewStep = (step, stepInfo) => {
        setCurrentStep({ index: step, type: stepInfo.type });
        if (stepInfo.type == 'product-select') {
            setCurrentFocusedComponent(stepInfo.componentIndex);
            setCurrentFocusedProduct(0);
        }
    };
    const editAddOns = () => {
        const stepIndex = steps[currentFocusedBaseProduct].findIndex((step) => step.stepInfo.type == 'add-ons');
        setCurrentStep({ index: stepIndex, type: 'add-ons' });
        setOpenStepAccordion(stepIndex);
    };
    const randomise = () => {
        const updatedBundle = currentSelectedBundle;
        const newBundle = updatedBundle.map((bundle) => {
            const randomVariants = findRandomVariants(bundle);
            return randomVariants;
        });
        setCurrentSelectedBundle([...newBundle]);
        setBundleEdited((prev) => ({ count: prev.count + 1, context: 'main', element: 'part' }));
    };
    if (!currentSelectedBundle || !allImagesDynamicData.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        isCustomisable == true ? (React.createElement("button", { className: "fg-cust--customise-btn", onClick: openModal },
            React.createElement("div", { className: "badge__inner" }, strings.customise_title))) : null,
        steps.length ? (React.createElement(CustomiseModal
        // Portals
        , { 
            // Portals
            customiserProductImage: customiserProductImage, summaryBar: summaryBar, customiserTools: customiserTools, 
            // Misc
            currentBundle: currentSelectedBundle, currentFocusedBaseProduct: currentFocusedBaseProduct, currentFocusedComponent: currentFocusedComponent, currentFocusedProduct: currentFocusedProduct, bundleComponents: bundleComponents, closeModal: closeModal, productHandle: bundleComponents[currentFocusedBaseProduct].product.handle, productTitle: bundleComponents[currentFocusedBaseProduct].product.title, productShortTitle: bundleComponents[currentFocusedBaseProduct].product.short_title, modalOpen: modalOpen, addOns: addOns, strings: strings, loadingNewPart: loadingNewPart, allImages: allImages, allImagesDynamicData: allImagesDynamicData, currentAddOns: currentAddOns, steps: steps[currentFocusedBaseProduct], currentStep: currentStep, thumbnailArtwork: thumbnailArtwork, addOnArtwork: addOnArtwork, disableBannedWord: disableBannedWord, settings: settings, baseProduct: baseProduct, monogrammingActive: monogrammingActive[currentFocusedBaseProduct], monogrammingBackActive: monogrammingBackActive[currentFocusedBaseProduct], isGiftSet: isGiftSet, selectNewComponent: selectNewComponent, selectPartColor: selectPartColor, toggleAddOnProduct: toggleAddOnProduct, selectAddOnPartColor: selectAddOnPartColor, editMonogramming: editMonogramming, selectEmoji: selectEmoji, sortSwatches: sortSwatches, setUniqueID: setUniqueID, generateThumbnail: generateThumbnail, selectNewStep: selectNewStep, selectPartToEdit: selectPartToEdit, openStepAccordion: openStepAccordion, setOpenStepAccordion: setOpenStepAccordion, editAddOns: editAddOns, updateMonogrammingPlacement: updateMonogrammingPlacement, 
            // Checkout Images / Add to cart
            checkoutImage: customCheckoutImage, checkoutRegion: settings.checkout_icon_region, replaceCheckoutImage: replaceCheckoutImage, checkoutGiftsetSuffix: baseProduct.checkout_giftset })) : null,
        mediaWrapper &&
            createPortal(React.createElement(React.Fragment, null,
                showRandomiseBtn ? (React.createElement("button", { className: "fg-cust--randomise-btn", onClick: randomise },
                    React.createElement("div", { className: "badge__inner" },
                        React.createElement("span", null, strings.randomise_btn),
                        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 26 26", fill: "none" },
                            React.createElement("path", { d: "M15.5273 20.4113L15.8157 21.0656L7.44041 24.7567L7.15204 24.1024L15.5273 20.4113ZM16.4788 17.9603L12.7877 9.58503C12.3736 8.64547 11.2762 8.21948 10.3367 8.63356L1.96142 12.3247C1.02186 12.7388 0.595875 13.8361 1.00995 14.7757L4.70106 23.1509C5.11514 24.0905 6.21248 24.5165 7.15204 24.1024L7.44041 24.7567L7.37924 24.7827C6.11265 25.303 4.65812 24.7384 4.07432 23.4998L4.04675 23.4393L0.355637 15.064C-0.20874 13.7834 0.353965 12.2911 1.61256 11.6979L1.67305 11.6704L10.0483 7.97925L10.1095 7.9532C11.3965 7.42452 12.8776 8.01607 13.442 9.29666L17.1331 17.6719L17.1591 17.7331C17.6794 18.9997 17.1148 20.4542 15.8762 21.038L15.8157 21.0656L15.5273 20.4113C16.4669 19.9972 16.8928 18.8998 16.4788 17.9603Z" }),
                            React.createElement("path", { d: "M2.91084 15.1882C2.59232 14.4654 2.92 13.6213 3.64274 13.3028C4.36548 12.9843 5.20959 13.3119 5.52811 14.0347C5.84663 14.7574 5.51895 15.6015 4.79621 15.9201C4.07347 16.2386 3.22936 15.9109 2.91084 15.1882Z" }),
                            React.createElement("path", { d: "M11.8453 18.4395C11.5267 17.7168 11.8544 16.8727 12.5772 16.5542C13.2999 16.2356 14.144 16.5633 14.4625 17.2861C14.7811 18.0088 14.4534 18.8529 13.7306 19.1714C13.0079 19.49 12.1638 19.1623 11.8453 18.4395Z" }),
                            React.createElement("path", { d: "M7.43573 16.9447C7.11721 16.222 7.44489 15.3779 8.16763 15.0593C8.89036 14.7408 9.73447 15.0685 10.053 15.7912C10.3715 16.514 10.0438 17.3581 9.3211 17.6766C8.59836 17.9951 7.75425 17.6674 7.43573 16.9447Z" }),
                            React.createElement("path", { d: "M11.9845 2.52625C12.5585 1.24998 14.0434 0.66948 15.3264 1.20779L15.3878 1.23439L23.735 4.98856L23.7945 5.01613C25.0485 5.6188 25.6008 7.11563 25.0269 8.3919L21.2727 16.7391L21.2442 16.7996C20.6716 17.9906 19.2939 18.5449 18.0634 18.1059L17.6393 17.1434L18.1619 17.3788C19.0983 17.7999 20.1993 17.3821 20.6205 16.4456L24.3747 8.09842C24.7956 7.16215 24.3777 6.06198 23.4415 5.64078L15.0943 1.88661C14.1579 1.46545 13.0569 1.88331 12.6357 2.81972L10.7823 6.93874L10.7696 6.92599L9.81587 7.34623L11.9845 2.52625ZM17.1635 13.3232C17.4875 12.6029 18.3346 12.2818 19.0549 12.6057C19.7748 12.9298 20.0961 13.776 19.7724 14.4961C19.4484 15.2165 18.6013 15.5376 17.881 15.2136C17.1609 14.8896 16.8397 14.0434 17.1635 13.3232ZM19.8619 7.32358C20.1859 6.60334 21.0321 6.28231 21.7523 6.60609C22.4725 6.93001 22.7945 7.77627 22.4708 8.49651C22.1468 9.21683 21.2997 9.53796 20.5794 9.21399C19.8593 8.88994 19.538 8.0438 19.8619 7.32358ZM13.602 4.50795C13.926 3.78774 14.7721 3.46652 15.4924 3.79047C16.2126 4.11446 16.5337 4.96064 16.2099 5.68088C15.8859 6.40116 15.0398 6.72224 14.3195 6.39836C13.5992 6.0744 13.278 5.22826 13.602 4.50795Z" }))))) : null,
                React.createElement("div", { className: "dark-mode__toggle-container", onClick: () => {
                        document.body.classList.toggle('body--mode-dark');
                    } },
                    React.createElement("button", { className: "dark-mode__toggle" },
                        React.createElement("div", { className: "toggle__icon-container" },
                            React.createElement("svg", { className: "toggle__icon toggle__icon--mode-light", xmlns: "http://www.w3.org/2000/svg", width: "15", height: "15", viewBox: "0 0 15 15", fill: "none" },
                                React.createElement("path", { d: "M8.20292 0.479738L8.91279 2.21553C9.02999 2.50211 9.37658 2.61472 9.63984 2.45178L11.2344 1.46474C11.6653 1.198 12.2028 1.58846 12.0822 2.08074L11.6363 3.90228C11.5626 4.20301 11.7768 4.49785 12.0856 4.52075L13.9558 4.65949C14.4612 4.69699 14.6665 5.32876 14.2797 5.65618L12.8482 6.86767C12.6119 7.0677 12.6119 7.43212 12.8482 7.63215L14.2797 8.84366C14.6666 9.17108 14.4613 9.80285 13.9558 9.84035L12.0856 9.97909C11.7769 10.002 11.5626 10.2968 11.6363 10.5976L12.0822 12.4191C12.2028 12.9114 11.6653 13.3018 11.2344 13.0351L9.63987 12.0481C9.37661 11.8851 9.02999 11.9977 8.91281 12.2843L8.20295 14.0201C8.0111 14.4892 7.34681 14.4892 7.15496 14.0201L6.4451 12.2843C6.32789 11.9977 5.9813 11.8851 5.71804 12.0481L4.12346 13.0351C3.69253 13.3018 3.15509 12.9114 3.27564 12.4191L3.7216 10.5976C3.79524 10.2968 3.58102 10.002 3.27225 9.97909L1.40205 9.84035C0.896642 9.80285 0.691356 9.17108 1.0782 8.84366L2.50964 7.63217C2.74597 7.43215 2.74597 7.06773 2.50964 6.8677L1.07817 5.65618C0.6913 5.32876 0.896587 4.69699 1.40203 4.65949L3.27222 4.52075C3.581 4.49785 3.79521 4.20301 3.72157 3.90228L3.27561 2.08074C3.15509 1.58846 3.69253 1.198 4.12344 1.46474L5.71801 2.45178C5.98128 2.61475 6.32786 2.50214 6.44507 2.21553L7.15493 0.479738C7.34678 0.0106601 8.01107 0.0106601 8.20292 0.479738ZM11.4625 7.24992C11.4625 5.16365 9.76517 3.46636 7.67893 3.46636C5.59265 3.46636 3.89537 5.16365 3.89537 7.24992C3.89537 9.33619 5.59265 11.0335 7.67893 11.0335C9.76517 11.0335 11.4625 9.33619 11.4625 7.24992ZM10.5722 7.24992C10.5722 8.84531 9.27431 10.1432 7.67893 10.1432C6.08354 10.1432 4.78562 8.84531 4.78562 7.24992C4.78562 5.65454 6.08354 4.35661 7.67893 4.35661C9.27431 4.35661 10.5722 5.65454 10.5722 7.24992Z", fill: "#2A213F" })),
                            React.createElement("svg", { className: "toggle__icon toggle__icon--mode-dark", xmlns: "http://www.w3.org/2000/svg", width: "13", height: "15", viewBox: "0 0 13 15", fill: "none" },
                                React.createElement("path", { d: "M7.46069 14.0875C9.52544 14.0875 11.4112 13.128 12.6606 11.5558C12.8454 11.3232 12.6438 10.9835 12.3582 11.039C9.11046 11.6708 6.12796 9.12738 6.12796 5.7788C6.12796 3.84991 7.13893 2.07616 8.78201 1.12111C9.03529 0.973897 8.97159 0.581693 8.68379 0.527396C8.28034 0.45141 7.87094 0.413148 7.46069 0.413086C3.76563 0.413086 0.766602 3.47143 0.766602 7.2503C0.766602 11.0244 3.76092 14.0875 7.46069 14.0875Z", fill: "#FCFBF5" })))),
                    React.createElement("div", { className: "dark-mode__cta" },
                        React.createElement("span", { className: "cta cta--for-dark" }, "See me glow!"),
                        React.createElement("span", { className: "cta cta--for-light" }, "See me in the day!")))), mediaWrapper),
        createPortal(React.createElement(React.Fragment, null, baseProduct.variants.length > 1 && baseProduct.has_components == false && isGiftSet == false ? (React.createElement(React.Fragment, null,
            React.createElement(VariantImageCarousel, { product: baseProduct, productImages: allImages[0][Object.values(currentSelectedBundle[currentFocusedBaseProduct])[currentFocusedComponent][currentFocusedProduct].part], dynamicData: allImagesDynamicData[0][Object.values(currentSelectedBundle[currentFocusedBaseProduct])[currentFocusedComponent][currentFocusedProduct].part], baseProductIndex: currentFocusedBaseProduct, componentIndex: currentFocusedComponent, productIndex: currentFocusedProduct, productHandle: bundleComponents[currentFocusedBaseProduct].product.handle, selectPartColor: selectPartColor, isActive: true, modalOpen: true }))) : (React.createElement(React.Fragment, null,
            React.createElement(EditButtons
            // Misc.
            , { 
                // Misc.
                currentBundle: currentSelectedBundle, bundleComponents: bundleComponents, currentFocusedBaseProduct: currentFocusedBaseProduct, currentFocusedComponent: currentFocusedComponent, currentFocusedProduct: currentFocusedProduct, modalOpen: modalOpen, currentStep: currentStep, isGiftSet: isGiftSet, customClass: "edit-buttons--pdp", baseProductHandle: baseProduct.handle, currentAddOns: currentAddOns, selectPartToEdit: selectPartToEdit, setOpenStepAccordion: setOpenStepAccordion, editAddOns: editAddOns }),
            React.createElement(DynamicImage, { currentAddOns: currentAddOns, currentStep: currentStep, allImages: allImages, allImagesDynamicData: allImagesDynamicData, productHandle: baseProduct.handle, baseProductIndex: currentFocusedBaseProduct, componentIndex: currentFocusedComponent, productIndex: currentFocusedProduct, selectPartColor: selectPartColor, showCustomiserImage: false, showCarousel: false })))), staticProductImage),
        summaryBar &&
            createPortal(React.createElement("div", { className: "summary-bar summary-bar--static" },
                React.createElement("div", { className: `summary-bar__info ${showSummaryBar ? `summary-bar__info--open` : ''}` },
                    React.createElement("h4", { className: "summary-bar__title" }, strings.summary),
                    isGiftSet ? (React.createElement(GiftSetButtons, { currentBundle: currentSelectedBundle, bundleComponents: bundleComponents, currentFocusedBaseProduct: currentFocusedBaseProduct, selectPartToEdit: selectPartToEdit, customClass: "gift-set-buttons--summary-bar" })) : (React.createElement(SummaryProducts, { currentBundle: currentSelectedBundle, currentAddOns: currentAddOns }))),
                React.createElement(AddToCartButton, { extraClass: 'summary-bar__atc', currentBundle: currentSelectedBundle, currentAddOns: currentAddOns, product: baseProduct, strings: strings, giftSetPrefix: settings.gift_set_properties, thumbnailArtwork: thumbnailArtwork, addOnArtwork: addOnArtwork, closeModal: closeModal, setUniqueID: setUniqueID, generateThumbnail: generateThumbnail, disableBannedWord: disableBannedWord, bundleComponents: bundleComponents, checkoutImage: customCheckoutImage, checkoutRegion: settings.checkout_icon_region, replaceCheckoutImage: replaceCheckoutImage, checkoutGiftsetSuffix: baseProduct.checkout_giftset }),
                React.createElement("button", { className: `summary-bar__toggle ${showSummaryBar ? `summary-bar__toggle--open` : ''}`, onClick: () => {
                        setShowSummaryBar(!showSummaryBar);
                    } },
                    React.createElement("span", null, "Summary"),
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512" },
                        React.createElement("path", { d: "M4.465 366.475l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L224 178.053l195.494 195.493c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-211.05-211.051c-4.686-4.686-12.284-4.686-16.971 0L4.465 349.505c-4.687 4.686-4.687 12.284 0 16.97z" })))), summaryBar),
        variantsWrapper &&
            baseProduct.variants.length > 1 &&
            createPortal(React.createElement(SwatchGrid, { product: Object.values(currentSelectedBundle[currentFocusedBaseProduct])[currentFocusedComponent][currentFocusedProduct], productIndex: currentFocusedProduct, componentIndex: currentFocusedComponent, baseProdIndex: currentFocusedBaseProduct, selectPartColor: selectPartColor, sortSwatches: sortSwatches, title: "Colour" }), variantsWrapper),
        thumbnailContainer &&
            createPortal(React.createElement(React.Fragment, null,
                React.createElement(ExportCanvas, { allImages: allImages, allImagesDynamicData: allImagesDynamicData, exportCanvasRef: exportCanvasRef, productHandle: baseProduct.handle }),
                currentAddOns.map((addOn) => (React.createElement(ExportAddOnsCanvas, { key: `add-on-canvas-${addOn.index}`, addOnItem: addOn, exportAddOnsCanvasRef: exportAddOnsCanvasRef.current[addOn.index] })))), thumbnailContainer),
        addToCartButtonContainer &&
            createPortal(React.createElement(React.Fragment, null,
                React.createElement(AddToCartButton, { extraClass: 'summary-bar__atc', currentBundle: currentSelectedBundle, currentAddOns: currentAddOns, product: baseProduct, strings: strings, giftSetPrefix: settings.gift_set_properties, thumbnailArtwork: thumbnailArtwork, addOnArtwork: addOnArtwork, closeModal: closeModal, setUniqueID: setUniqueID, generateThumbnail: generateThumbnail, disableBannedWord: disableBannedWord, bundleComponents: bundleComponents, 
                    // Image
                    checkoutImage: customCheckoutImage, checkoutRegion: settings.checkout_icon_region, replaceCheckoutImage: replaceCheckoutImage, checkoutGiftsetSuffix: baseProduct.checkout_giftset })), addToCartButtonContainer)));
};
export default CustomiserBase;
